import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { DELETE_DMX_DEVICE } from './actionTypes';
import { deleteDmxDeviceSuccessful, deleteDmxDeviceFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* deleteDevice({ payload: { device } }) {
  try {
    const response = yield call(dmxAPI.deleteDevice, device.token, device.id);
    if (response.message) {
      yield put(deleteDmxDeviceSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(deleteDmxDeviceFailed(error));
  }
}

export function* watchDeleteDmxDevice() {
  yield takeEvery(DELETE_DMX_DEVICE, deleteDevice);
}

function* deleteDmxDeviceSaga() {
  yield all([fork(watchDeleteDmxDevice)]);
}

export default deleteDmxDeviceSaga;
